import { Component } from '@angular/core';

@Component({
  selector: 'ui-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent {
}
